import Axios from "axios";
import AiDefaults from "../domain/AiDefaults";

class AiDefaultsService {

    readonly basePath = "/ai-defaults";

    public get(): Promise<AiDefaults> {
        return Axios.get(this.basePath)
            .then(value => AiDefaults.fromPOJO(value.data));
    }

    public update(values: Record<string, string | null>): Promise<void> {
        return Axios.put(this.basePath, {values});
    }
}

export default AiDefaultsService;
